import * as React from "react";
import { Alert } from "components/bootstrap";
import { PaginationProvider, SelectedRowsProvider, ModalProvider } from "common/contexts";
import SigmaModals from "security-app/components/SigmaRules/ImportRulesModal";
import SearchRow from "security-app/components/SigmaRules/SearchRow";
import List from "security-app/components/SigmaRules/List";
import { TextOverflowEllipsis, Spinner } from "components/common";
import useThreatRelatedSigmaRules, { sigmaRulesQuery } from "./useThreatRelatedSigmaRules";
const SigmaRulesEnable = ({ coverageEntity }) => {
  const { loadingRules, notEnabledRules, allRules } = useThreatRelatedSigmaRules(coverageEntity);
  if (loadingRules) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(PaginationProvider, { initQuery: sigmaRulesQuery(coverageEntity) }, /* @__PURE__ */ React.createElement(SelectedRowsProvider, null, /* @__PURE__ */ React.createElement(ModalProvider, null, allRules.length > 0 && notEnabledRules.length === 0 ? /* @__PURE__ */ React.createElement(Alert, { bsStyle: "success" }, "All related Sigma Rules have been activated") : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SearchRow, { hideSearchForm: true, visibleBulkActions: ["enable", "disable"] }), /* @__PURE__ */ React.createElement(
    List,
    {
      visibleColumns: ["title", "enabled"],
      displayRowActions: false,
      onlyMatchingSystemConfig: true,
      renderRowTitle: (rule) => /* @__PURE__ */ React.createElement(TextOverflowEllipsis, null, rule.title),
      noSearchResultText: "None of the Sigma rules in your enabled Illuminate packs apply to your current log sources. To see relevant rules, add compatible log sources or enable other Illuminate packs."
    }
  )), /* @__PURE__ */ React.createElement(SigmaModals, null))));
};
export default SigmaRulesEnable;
